<template>
  <div class="cd-taken">
    <section v-for="section in sections" :key="section.key" class="cd-taken__section">
      <div v-if="section.name" class="rd-section">
        <h2>{{ section.name }}</h2>
        <span class="rd-num">
          <template v-if="showTaken"><b>{{ section.taken }}</b> / {{ section.ordered }}</template>
          <template v-else>{{ section.ordered }}</template>
        </span>
      </div>

      <div class="rd-card">
        <table class="rd-tbl">
          <thead>
            <tr>
              <th scope="col">{{ nameLabel }}</th>
              <th v-for="shift in shifts" :key="shift.id" scope="col" class="is-right">
                <report-shift-tag :shift="shift.id"></report-shift-tag>
              </th>
              <th scope="col" class="is-right">{{ $t("total") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in section.rows" :key="row.key">
              <td class="is-name" :title="row.name">{{ row.name }}</td>
              <td v-for="shift in shifts" :key="shift.id" class="is-right">
                <template v-if="row.cells[shift.id].ordered">
                  <span
                    v-if="showTaken"
                    class="rd-cellbar"
                    :class="{ 'is-complete': row.cells[shift.id].complete }"
                  >
                    <span class="rd-cellbar__text">
                      {{ row.cells[shift.id].taken }} / {{ row.cells[shift.id].ordered }}
                    </span>
                    <span class="rd-cellbar__bar"><i :style="{ width: `${row.cells[shift.id].percent}%` }"></i></span>
                  </span>
                  <span v-else class="rd-num">{{ row.cells[shift.id].ordered }}</span>
                </template>
                <span v-else class="is-zero">–</span>
              </td>
              <td class="is-right rd-num">
                <template v-if="showTaken">
                  <b>{{ row.taken }}</b> / {{ row.ordered }}
                  <span class="rd-mini" :class="{ 'is-complete': row.complete }">
                    <i :style="{ width: `${row.percent}%` }"></i>
                  </span>
                </template>
                <b v-else>{{ row.ordered }}</b>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>{{ $t("total") }}</td>
              <td v-for="shift in shifts" :key="shift.id" class="is-right rd-num">
                <template v-if="totals(section).cells[shift.id].ordered">
                  <template v-if="showTaken">
                    {{ totals(section).cells[shift.id].taken }} / {{ totals(section).cells[shift.id].ordered }}
                  </template>
                  <template v-else>{{ totals(section).cells[shift.id].ordered }}</template>
                </template>
                <template v-else>–</template>
              </td>
              <td class="is-right rd-num">
                <template v-if="showTaken">{{ section.taken }} / {{ section.ordered }}</template>
                <template v-else>{{ section.ordered }}</template>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import ReportShiftTag from "@/components/report/shared/ReportShiftTag.vue";

/**
 * Tabela "preuzeto / poručeno" po smenama za izveštaje firme na računaru (Preuzeti obroci, Preuzeto, Preuzeto po
 * firmama): redovi su obroci ili firme, kolone smene sa trakom napretka, pa ukupno. Samo prikazuje; podatke,
 * pretragu, štampu i Excel daje ekran. Bez `showTaken` (firma ne sme da vidi preuzimanje) prikazuje samo poručeno.
 */
export default {
  name: "CompanyDesktopTakenTable",
  components: { ReportShiftTag },
  props: {
    /** [{ key, name, ordered, taken, rows: [{ key, name, ordered, taken, percent, complete, cells: { [smena]: { ordered, taken, percent, complete } } }] }] */
    sections: { type: Array, default: () => [] },
    /** smene koje su kolone: [{ id, key, label }] */
    shifts: { type: Array, default: () => [] },
    nameLabel: { type: String, default: "" },
    showTaken: { type: Boolean, default: true },
  },
  methods: {
    /** Zbir po smeni za podnožje (ostaje u skladu sa prikazanim redovima). */
    totals(section) {
      const cells = {};
      this.shifts.forEach((shift) => {
        cells[shift.id] = section.rows.reduce(
          (sum, row) => ({
            ordered: sum.ordered + row.cells[shift.id].ordered,
            taken: sum.taken + row.cells[shift.id].taken,
          }),
          { ordered: 0, taken: 0 }
        );
      });
      return { cells };
    },
  },
};
</script>

<style lang="scss">
.cd-taken__section + .cd-taken__section {
  margin-top: 20px;
}
</style>
